import classNames from "classnames";
import { useRef } from "react";

import { useLockBodyScrollModified } from "@/hooks/useLockBodyScrollModified";
import { useModalAppearing } from "@/hooks/useModalAppearing";

import styles from "./PopupContainer.module.scss";

interface PopupContainerProps {
  isOpen: boolean;
  close(): void;
  children: React.ReactNode;
  className?: string;
}

const PopupContainer = ({
  isOpen,
  close,
  children,
  className = "",
}: PopupContainerProps) => {
  const { isVisible, mounting, hiding } = useModalAppearing({ isOpen });
  useLockBodyScrollModified(isOpen);
  const containerRef = useRef<HTMLDivElement | null>(null);

  if (!isVisible) return null;
  return (
    <div
      className={classNames(className, {
        [styles.show]: mounting,
        [styles.hide]: hiding,
      })}
      ref={containerRef}
    >
      <div
        className={styles.closeArea}
        onClick={(e) => {
          e.stopPropagation();
          close();
        }}
      />
      {children}
    </div>
  );
};

export default PopupContainer;
